module.exports = __webpack_public_path__ + "static/img/qrcode2.821afdb6.png";